export interface IClcScoresMoreDetails {
    id: number,
    adpDonor: string,
    adpRecipient: string,
    surgeryDate: string,
    donorABO: string,
    recipientABO: string,
    pointType: string,
    clcPoints: number,
    donorAlias: string,
    donorType: string,
    recipientAlias: string,
    swap: string,
    adjustment: number,
    cPRA: number,
    pdabo: string,
    pmPc: number,
    compPair: string,
    offerDate: string,
    acceptDate: string,
    reversalDate: string,
    rootCause: string,
    cPRADeduct: number,
    btCombo: number,
    totalFclcAdjust: number
}